import React, { ChangeEvent, useState } from "react";
import "./file-upload.scss";
import { ArrowUpward } from "../../SVG/arrow-upward";
import BlackEyeIcon from "../../SVG/black-eye";
import DeleteBinIcon from "../../SVG/delete-bin";

interface FileUploadProps {
  id?: string;
  file?: File;
  fileName?: string;
  reUpload?: boolean;
  deleteUploadedFile: () => void;
}

export function FileUpload(props: FileUploadProps) {
  const [filesArray, setFilesArray] = useState<File[]>([]);
  const [reUpload] = useState<boolean>(false);

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>): void => {
    const files = event.target.files;

    if (files) {
      const newFiles: File[] = Array.from(files);
      setFilesArray((prevFiles) => {
        const unionOfFiles = [...new Set([...prevFiles, ...newFiles])];
        return unionOfFiles;
      });
    }
  };

  const deleteFile = (indexToDelete: any) => {
    console.log(indexToDelete);
    setFilesArray((prevFiles) => {
      const updatedFiles = [...prevFiles];
      updatedFiles.splice(indexToDelete, 1);
      // setReUpload(!reUpload);
      return updatedFiles;
    });
  };

  return (
    <>
      <div className="upload-button-container">
        <label htmlFor={props.id}>
          <ArrowUpward />
          <div>Upload Document</div>
        </label>
        <input
          type="file"
          id={props.id}
          name={props.id}
          accept=".jpg, .jpeg, .png, .pdf"
          style={{ display: "none" }}
          onChange={handleFileChange}
          multiple
        />
      </div>

      {filesArray.map((file, index) => (
        <>
          <UploadedFileView
            fileName={file.name}
            file={file}
            deleteUploadedFile={() => deleteFile(index)}
            reUpload={reUpload}
          />
        </>
      ))}
    </>
  );
}

function UploadedFileView(props: FileUploadProps) {
  return (
    <>
      <div className="document-holder-container">
        <div className="document-name">{props.fileName}</div>
        <div className="document-icons">
          <BlackEyeIcon />
          <DeleteBinIcon />
        </div>
      </div>
    </>
  );
}
